import { Link } from "react-router-dom";
import { CheckCircle2, Home, PackageSearch } from "lucide-react";
import { useCart } from "../../lib/CartContext";

export default function CartSuccessStep() {
  const { lastOrder } = useCart();

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="cart-order-success">
      <div className="w-20 h-20 rounded-full bg-[#A85C34]/10 flex items-center justify-center mb-6">
        <CheckCircle2 className="w-9 h-9 text-[#A85C34]" />
      </div>
      <h1 className="font-serif text-3xl mb-3">Teşekkürler!</h1>
      <p className="text-sm text-[#888888] max-w-sm mb-2">
        Siparişiniz alındı. En kısa sürede sizinle iletişime geçeceğiz.
      </p>

      {lastOrder?.id && (
        <div className="mb-8 px-6 py-4 rounded-2xl bg-[#F8F8F8] border border-[#EAEAEA]" data-testid="cart-order-number">
          <p className="text-xs text-[#888888] mb-1">Sipariş Numaranız</p>
          <p className="font-serif text-2xl text-[#A85C34] font-bold">#{lastOrder.number ?? lastOrder.id}</p>
          <p className="text-xs text-[#888888] mt-1.5">
            Bu numarayı ve sipariş verirken kullandığınız telefon numaranızı,{" "}
            <Link to="/siparis-takibi" className="text-[#A85C34] font-medium hover:underline">
              sipariş takibi
            </Link>{" "}
            için saklayın.
          </p>
        </div>
      )}

      <div className="flex flex-col sm:flex-row items-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#A85C34] hover:bg-[#8B4726] text-white rounded-full font-medium transition-colors"
        >
          <Home className="w-4 h-4" />
          Ana Sayfaya Dön
        </Link>
        <Link
          to="/siparis-takibi"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-white border border-[#EAEAEA] hover:border-[#A85C34] text-[#222222] rounded-full font-medium transition-colors"
        >
          <PackageSearch className="w-4 h-4" />
          Siparişimi Takip Et
        </Link>
      </div>
    </div>
  );
}
